import { Order, OrderStatus } from '../interfaces/order.interface';

const parsePutCheckoutToOrder = (data: any, id: string): Order => {
  const order: Order = {
    id,
    referenceNumber: data.id,
    status: OrderStatus.AUTHORIZED,
    details: { ...data },
  };

  return order;
};

export default parsePutCheckoutToOrder;
